var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1727-684h1920v1080h-1920z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:none}.b{fill:#f9a03b}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m0 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.5,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 9,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 19.5,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m19.9 19.7c-0.2 1-1 2-2.3 2.3-0.7 0.1-3-0.5-5.5-0.5h-0.2c-2.5 0-4.8 0.6-5.5 0.5-1.4-0.3-2.1-1.3-2.4-2.3-0.3-2.1 1.3-3.5 2.6-4.8 0.9-1.1 1.7-1.9 2.5-2.9 0.5-0.6 1.1-1.1 1.8-1.4q0.1 0 0.3-0.1 0.4 0 0.8 0 0.4 0 0.8 0 0.1 0.1 0.3 0.1c0.7 0.3 1.3 0.8 1.8 1.3 0.8 1.1 1.6 1.9 2.4 3 1.3 1.3 3 2.7 2.6 4.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.d2f84e467e74ae719b081c81e4a9dd00.svg";
export { ForwardRef as ReactComponent };